<template>
  <div class="d-flex justify-start align-center pt-6">
    <ConfirmRegisterDialog
      :state="confirmStudentDialog"
      :importedDocuments="importedDocuments"
      @closeDialog="closeConfirmDialog"
      @updateResult="onUpdateResultDocument"
      ref="registerDialog"
    />
    <InvalidCodeDialog
      :state="invalidDialog"
      :invalidCode="invalidCode"
      :invalidExamCode="invalidExamCode"
      :invalidSubjects="invalidSubjects"
      @closeDialog="closeInvalid"
    />
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mt-0 ml-6" color="green" dark v-bind="attrs" v-on="on" outlined>
          Nhập/xuất Excel học sinh
        </v-btn>
      </template>

      <v-list>
        <v-list-item class="cursor-pointer">
          <v-list-item-title @click="onUploadClick">Tải lên tệp Excel chứa thông tin học sinh</v-list-item-title>
          <input
            ref="uploader"
            type="file"
            class="d-none"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="onFileChanged"
          />
        </v-list-item>
        <v-list-item class="cursor-pointer">
          <v-list-item-title @click="exportDataToExcel">Tải xuống tệp Excel</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { mapActions, mapGetters } from 'vuex'
import readXlsxFile from 'read-excel-file'
import * as XLSX from 'xlsx'
import { StudentExam } from '@/plugins/api'
import ConfirmRegisterDialog from './ConfirmRegisterDialog.vue'
import InvalidCodeDialog from './InvalidCodeDialog.vue'
import moment from 'moment'

const schema = {
  'Họ tên': {
    prop: 'name',
    type: String
  },
  'Mã học sinh': {
    prop: 'code_short',
    type: String,
    required: true
  },
  'Số báo danh': {
    prop: 'examCode',
    type: String
  },
  'Tổ hợp thi': {
    prop: 'subjectGroup',
    type: String
  }
}

export default {
  components: { ConfirmRegisterDialog, InvalidCodeDialog },
  props: {
    exam: String,
    query: Object
  },
  data() {
    return {
      dialog: false,
      students: null,
      confirmStudentDialog: false,
      isSelecting: false,
      invalidDialog: false,
      invalidCode: [],
      invalidExamCode: [],
      invalidSubjects: [],
      importedDocuments: [],
      json_fields: {
        'Họ tên': 'student.name',
        'Mã học sinh': 'student.code_short',
        'Số báo danh': 'examCode',
        'Ngày tạo': 'student.createdAt',
        'Tổ hợp thi': 'subjectGroup.name'
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'isAuthenticated'])
  },
  methods: {
    ...mapActions('studentExam', ['fetchStudentExams']),
    onUploadClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      this.$refs.uploader.click()
    },

    async getStudentExcel() {
      this.$loading.active = true
      console.log(this.query)
      const students = await this.fetchStudentExams({
        exam: this.exam,
        ...this.query,
        _limit: -1,
        _sort: 'examCode:asc'
      })
      this.students = students
      this.$loading.active = false
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema
        })
      } catch (error) {
        console.error(error)
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const data = readFileResult.rows
        this.importedDocuments = data
        this.confirmStudentDialog = true
      }
      this.$loading.active = false
    },
    formatDataForExport(data) {
      return data.map(item => {
        let formattedItem = {}
        for (let key in this.json_fields) {
          const fieldPath = this.json_fields[key]
          let value = item
          if (typeof fieldPath === 'string') {
            const pathParts = fieldPath.split('.')
            pathParts.forEach(part => {
              if (value) {
                value = value[part]
              }
            })
          }
          if ((key === 'Ngày sinh' || key === 'Ngày tạo') && value) {
            value = moment(value).format('DD/MM/YYYY')
          }

          formattedItem[key] = value || ''
          if (key === 'Số báo danh' && value) {
            formattedItem[key] = { v: value, t: 's' }
          }
        }
        return formattedItem
      })
    },
    async exportDataToExcel() {
      await this.getStudentExcel()
      const formattedData = this.formatDataForExport(this.students)

      const dataForSheet =
        formattedData.length > 0 ? formattedData : this.getHeaders().map(header => ({ [header]: '' }))

      const worksheet = XLSX.utils.json_to_sheet(dataForSheet, { header: this.getHeaders(), skipHeader: false })

      this.setColumnWidths(worksheet, dataForSheet)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Học sinh')

      XLSX.writeFile(workbook, 'hoc-sinh-dang-ky-mau.xlsx')
      this.$loading.active = false
    },
    getHeaders() {
      const headers = []
      for (let key in this.json_fields) {
        headers.push(key)
      }
      return headers
    },
    async onUpdateResultDocument(data) {
      this.$refs.uploader.value = null
      const fileData = {
        exam: this.exam,
        register: data
      }
      const assigned = await StudentExam.fileRegister(fileData)
      if (!assigned.invalidCode || !assigned.invalidExamCode) {
        this.closeConfirmDialog()
        this.$emit('refresh')
      } else {
        this.$refs.registerDialog.stopLoading()
        this.invalidCode = assigned.invalidCode
        this.invalidExamCode = assigned.invalidExamCode
        this.invalidSubjects = assigned.missingSubjects
        this.invalidDialog = true
      }
    },
    closeInvalid() {
      this.invalidDialog = false
      this.invalidRooms = ''
    },
    setColumnWidths(worksheet, data) {
      let maxWidths = []
      const columnNames = data.length > 0 ? Object.keys(data[0]) : []

      columnNames.forEach((name, index) => {
        maxWidths[index] = name.length
      })

      data.forEach(row => {
        columnNames.forEach((name, index) => {
          const value = (row[name] || '').toString().trim()
          maxWidths[index] = Math.max(maxWidths[index], value.length)
        })
      })
      worksheet['!cols'] = maxWidths.map(width => ({ width }))
    },
    closeConfirmDialog() {
      this.confirmStudentDialog = false
      this.$refs.uploader.value = null
    }
  }
}
</script>
